import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useDataMapping = (dataMappingId: string | undefined) => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    ["dataMapping", dataMappingId],
    async (api) => {
      if (!dataMappingId) {
        return;
      }

      return api.productionFulfillmentMappingsGetMappings({
        id: dataMappingId,
      });
    }
  );
};
